
import React, { useEffect, useState } from "react";
import axios from '../utils/axios';
import { toast } from 'react-toastify';
import Translate from '../components/translate/conf';
import ReactDOMServer from 'react-dom/server';
import {useTranslation} from 'react-i18next';

export default class SystemInfoPage extends React.Component {
  constructor(props) {
    super(props)
    axios('/api/systeminfo')
      .then((res) => {
        if (res.data.data !== undefined) {
          let enabled = ReactDOMServer.renderToString(<Translate transVar='SystemInfo.Services.Enabled' />)
          let disabled = ReactDOMServer.renderToString(<Translate transVar='SystemInfo.Services.Disabled' />)          
          res.data.data.enNtpServer = res.data.data.enNtpServer === '1' ? enabled : disabled
          res.data.data.enSNMPAgent = res.data.data.enSNMPAgent === '1' ? enabled : disabled
          res.data.data.dateTime = this.getDateFromDateBR(res.data.data.dateTime)
          this.setState(res.data.data)
        }
      })
      .catch((err) => {
        console.log(err)
        let label = ReactDOMServer.renderToString(<Translate transVar='error.label' />)
        toast.error(label + err)
      })
  }

  state = {
    uptime: '',
    fwVersion: '',
    product: '',
    serialNumber: '',
    mgntIpAddr: '',
    mgntIpMask: '',
    mgntIpGateway: '',
    ntpServer: '',
    enNtpServer: '',
    id: '',
  }

  getDateFromDateBR = (dateBr) => {
    let out = dateBr
    let parts = /^(\d+)\/(\d+)\/(\d+) (\d+):(\d+)$/.exec(dateBr)
    if( parts.length === 6 ){
      let dt = new Date(Date.UTC(parseInt(parts[3]),parseInt(parts[2])-1,parseInt(parts[1]),parseInt(parts[4]),parseInt(parts[5])))
      out = dt.toLocaleString([],{
        year:'numeric',
        month:'numeric',
        day:'numeric',
        hour:'2-digit',
        minute:'2-digit'
      })
    }
    return out
  }

  render() {
    return (
      <>
        <section className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h1><Translate transVar='menusidebar.label.SystemInfo' /></h1>
              </div>
              <div className="col-sm-6">
                <ol className="breadcrumb float-sm-right">
                  <li className="breadcrumb-item">
                    <Translate transVar='menusidebar.label.SystemInfo' />
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </section>
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-6">
                <div className="card card-primary">
                  <div className="card-body">
                    <div className="table-responsive">
                      <p className="lead"><Translate transVar='SystemInfo.GeneralInfo.Title' /></p>
                      <table className="table">
                        <tbody>
                          <tr>
                            <th><Translate transVar='SystemInfo.GeneralInfo.Uptime' /></th>
                            <td>{this.state.uptime}</td>
                          </tr>
                          <tr>
                            <th><Translate transVar='SystemInfo.GeneralInfo.DateTime' /></th>
                            <td>{this.state.dateTime}</td>
                          </tr>
                          <tr>
                            <th><Translate transVar='SystemInfo.GeneralInfo.FirmwareVersion' /></th>
                            <td>{this.state.fwVersion}</td>
                          </tr>
                          <tr>
                            <th><Translate transVar='SystemInfo.GeneralInfo.Product' /></th>
                            <td>{this.state.product}</td>
                          </tr>
{ (localStorage.getItem('showSerialNumber') === "true") &&
                          <tr>
                            <th><Translate transVar='SystemInfo.GeneralInfo.SerialNumber' /></th>
                            <td>{this.state.serialNumber}</td>
                          </tr>
}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="card card-primary">
                  <div className="card-body">
                    <div className="table-responsive">
                      <p className="lead"><Translate transVar='SystemInfo.NetworkInformation.Title' /></p>
                      <table className="table">
                        <tbody>
                          <tr>
                            <th><Translate transVar='SystemInfo.NetworkInformation.IPAddress' /></th>
                            <td>{this.state.mgntIpAddr}</td>
                          </tr>
                          <tr>
                            <th><Translate transVar='SystemInfo.NetworkInformation.Netmask' /></th>
                            <td>{this.state.mgntIpMask}</td>
                          </tr>
                          <tr>
                            <th><Translate transVar='SystemInfo.NetworkInformation.Gateway' /></th>
                            <td>{this.state.mgntIpGateway}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <div className="card card-primary">
                  <div className="card-body">
                    <div className="table-responsive">
                      <p className="lead"><Translate transVar='SystemInfo.Services.Title' /></p>
                      <table className="table">
                        <tbody>
                          <tr>
                            <th><Translate transVar='SystemInfo.Services.SNMPStatus' /></th>
                            <td>{this.state.enSNMPAgent}</td>
                          </tr>
                          <tr>
                            <th><Translate transVar='SystemInfo.Services.NTPStatus' /></th>
                            <td>{this.state.enNtpServer}</td>
                          </tr>
                          <tr>
                            <th><Translate transVar='SystemInfo.Services.NTPServerIP' /></th>
                            <td>{this.state.ntpServer}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </>
    )
  }
}
